import { createContext, useContext, useEffect, useState } from "react";
import { hostApi, setHostToken } from "@/lib/hostApi";

const HostAuthContext = createContext(null);

export function HostAuthProvider({ children }) {
  const [host, setHost] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await hostApi.get("/live/host/me");
      setHost(data.host);
    } catch {
      setHost(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await hostApi.post("/live/host/login", { email, password });
    setHostToken(data.host_session_token);
    setHost(data.host);
    return data.host;
  };

  const setupComplete = ({ host: h, host_session_token }) => {
    setHostToken(host_session_token);
    setHost(h);
  };

  const logout = async () => {
    try { await hostApi.post("/live/host/logout"); } catch { /* noop */ }
    setHostToken(null);
    setHost(null);
  };

  return (
    <HostAuthContext.Provider value={{ host, loading, login, logout, setupComplete, refresh }}>
      {children}
    </HostAuthContext.Provider>
  );
}

export function useHostAuth() {
  const ctx = useContext(HostAuthContext);
  if (!ctx) throw new Error("useHostAuth must be used inside HostAuthProvider");
  return ctx;
}
